const configState = {
	tempObjDirection: 'V', //客观题 的 题号 方向
	tempFillDirection: 'H', //填涂框 的 方向
	tempImgZoomRate: {}, // 缩放比
	tempActiveArea: null, // 激活框的index
	tempRotateArea: null,
	temObjFormat: {},
	tempRectTitle: [],
	tempCurrentImgIndex: { curIndex: 0 },
	tempRectExamNoInfo: {},
	tempScalePage: 1,
	tempEditImgInfo: {},
	tabActive: 'title',
	typeLack: {},
	tempChooseList: [],
	operateCurPage: {},
	tempSubList: [],
	tempSelLikeSubOrObjVal: [],
	tempExamNoType: 1,
	tempLack: {},
	tempRectObjective: {},
	tempRectSubjective: {},
	tempTopicCurrentIndex: -1,
	tempDelArea: null, // 删除选区
	tempScrollTop: 0,
	tempScrollLeft: 0,
	tempOriginFlag: false,
	tempFlushData: {},
	tempRightKeyFixRectInfo: {},
	groupListDetail: [],
	tempObjTabState: false,
	tempSubTabState: false,
	chooseTabState: false,
	dotType: {},
	tempSelLikeSubOrObj: '',
	tempSelLikeSubOrObjName: '',
	tempSliceTopic: {},
	tempFixRectTitle: {},
	tempExamObjAddRect: {},
	tempHandleReset: {},
	tempRectSliceList: [],
	handleSliceOriginClick: {},
	handHandleState: false,
	wsState: false,
	tempObjTopic: [],
	canDrawRect: true,
	handleSetObjVal: { state: false },
	copyObjState: { state: false },
	objCanKeyDel: true,
	tempReferTabState: false,
	tempCurrentRefer: { base64Img: '', pos: {}, image: '' },
	tempReferRectList: [],
	tempSelLikeSub: [],
	tempRowNum: 4,
	tempInitObjTopic: null
}
export default configState
